module.exports = __webpack_public_path__ + "media/images/flags/4x3/vat-c09c897ecb4e4223e83e6fccce98c664.svg";